import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccountService } from 'src/app/services/auth';
import { Order } from 'src/app/shared/models/orders';

@Component({
  selector: 'app-hormigon-dispatch-card',
  templateUrl: './hormigon-dispatch-card.component.html',
  styleUrls: ['./hormigon-dispatch-card.component.css'],
  standalone: false,
})
export class HormigonDispatchCardComponent implements OnChanges {
  @Input() order!: Order;
  @Input() title = 'Despacho actual';
  @Input() titleNumber: string | number | null = null;
  @Input() showAdditiveRemarks = true;
  @Input() showPreviousTruck = true;
  @Input() showOrderNumber = true;
  @Output() continue = new EventEmitter<Order>();
  @Output() paperGuide = new EventEmitter<Order>();
  guidePdfSrc: { data: Uint8Array } | null = null;
  guideLoading = false;
  guideError = false;

  constructor(private readonly accountService: AccountService) {}

  onContinue(): void {
    if (!this.isActive()) return;
    this.continue.emit(this.order);
  }

  onPaperGuide(): void {
    this.paperGuide.emit(this.order);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['order']) {
      void this.loadGuide();
    }
  }

  private async loadGuide(): Promise<void> {
    const routePdfGuide = this.order?.routePdfGuide;
    this.guidePdfSrc = null;
    this.guideError = false;

    if (!routePdfGuide) {
      return;
    }

    this.guideLoading = true;
    try {
      const response = await fetch(routePdfGuide);
      if (!response.ok) {
        throw new Error(`Guide HTTP ${response.status}`);
      }

      this.guidePdfSrc = { data: new Uint8Array(await response.arrayBuffer()) };
    } catch {
      this.guideError = true;
    } finally {
      this.guideLoading = false;
    }
  }

  deliveryDateOnly(value: string): string {
    if (value == null || value === '') return '';
    return value.trim().split(/[ T]/)[0];
  }

  toAmOrPm(time: string): string {
    if (time == null || time === '') return 'No disponible';
    const timeArray = time.split(':');
    const hour = parseInt(timeArray[0], 10);
    const minute = timeArray[1];
    if (hour >= 12) {
      return hour > 12 ? `${hour - 12}:${minute} PM` : `${hour}:${minute} PM`;
    }
    return `${hour}:${minute} AM`;
  }

  isActive(): boolean {
    return this.accountService.userValue.ESTADO === '1';
  }
}
